var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_metaMap.js
// module id = 700
// module chunks = 0 1 2 3 4 5 6 7 8